// extracted by mini-css-extract-plugin
export default {"jobDetailsAbout":"styles_jobDetailsAbout__nWgZB","jobDetailsAboutMain":"styles_jobDetailsAboutMain__WL4D9","moreDesc":"styles_moreDesc__wr1H8"};